import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-175ac089"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mt-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-center mb-5 text-muted" }, "Clients", -1))
const _hoisted_3 = { class: "device-health" }
const _hoisted_4 = { class: "row g-4" }
const _hoisted_5 = { class: "status-card shadow" }
const _hoisted_6 = { class: "status-card-body" }
const _hoisted_7 = { class: "status-title" }
const _hoisted_8 = { class: "status-value" }
const _hoisted_9 = { class: "text-primary" }
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Loading, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      "can-cancel": false,
      "is-full-page": true
    }, null, 8, ["active"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devices, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "col-12 col-md-3"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h6", _hoisted_7, _toDisplayString(item.title), 1),
                _createElementVNode("h2", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(item.current), 1),
                  (item.total)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, "/" + _toDisplayString(item.total), 1))
                    : _createCommentVNode("", true)
                ]),
                (item.trend)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: _normalizeClass(["status-text", item.trendClass])
                    }, _toDisplayString(_ctx.getTrendWord(item.trend)), 3))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}